import { BaseConfig } from '@shared/base-config';

export const Config = {
  ...BaseConfig,
  get customerPortalUrl(): string {
    return `${window.location.origin}${process.env['VUE_APP_CUSTOMER_PORTAL']}`;
  }
};
